<script setup lang="ts">
import { useCdnImages } from '../../../composables/use-cdn-images'

const { cdnImageUrl } = useCdnImages()
</script>

<template>
  <div class="bx-header__logo-wrapper">
    <a class="bx-header__logo"
       title="astrowoche.de"
       href="/">
      <img :src="cdnImageUrl('/images/astrowoche/astrowoche-logo.png')"
           alt="Astrowoche Logo"
           width="191"
           height="100">
    </a>
  </div>
</template>
